import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
import { format } from '@/@core/utils/string';
let SearchEngineManagementApi = class SearchEngineManagementApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        // #region  company
        /**
         * 获取公司索引
         */
        this.getCompaniesSolr = (params) => {
            const url = this.urls.getCompaniesSolr;
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 创建ES 结构
         * @param params
         * @returns
         */
        this.createCompanyIndexEs = () => {
            const url = this.urls.setCompaniesIndex;
            return this.http.post({
                url,
            });
        };
        /**
         * 清空ES
         * @returns
         */
        this.deleteCompanyIndexEs = () => {
            const url = this.urls.setCompaniesIndex;
            return this.http.delete({
                url,
            });
        };
        /**
         * 全量索引
         * @returns
         */
        this.setCompaniesReindex = () => {
            const url = this.urls.setCompaniesReindex;
            return this.http.get({
                url,
            });
        };
        /**
         * 创建公司索引
         */
        this.createCompaniesIndex = (params) => {
            const url = this.urls.createCompaniesIndex;
            return this.http.get({
                url,
                params,
            });
        };
        /**
        * 删除公司索引
        */
        this.deleteCompaniesIndex = (params) => {
            const url = format(this.urls.deleteCompaniesIndex, params);
            return this.http.delete({
                url,
            });
        };
        // #endregion
        // #region
        /**
         * 获取用户索引
         * 用于搜索
         * @param params
         * @returns
         */
        this.getEmailSolr = (params) => {
            const url = this.urls.getEmailSolr;
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 创建用户索引
         * @param params
         * @returns
         */
        this.createAccountsIndex = (params) => {
            const url = this.urls.createAccountsIndex;
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 删除用户索引
         */
        this.delAccountsIndex = (params) => {
            const url = format(this.urls.delAccountsIndex, params);
            return this.http.delete({
                url,
            });
        };
        /**
         * 创建用户ES
         */
        this.createAccountIndexEs = () => {
            const url = this.urls.setAccountsIndex;
            return this.http.post({
                url,
            });
        };
        /** 删除用户ES
         */
        this.deleteAccountIndexEs = () => {
            const url = this.urls.setAccountsIndex;
            return this.http.delete({
                url,
            });
        };
        /**
         * 全量索引
         */
        this.setAccountsReindex = () => {
            const url = this.urls.setAccountsReindex;
            return this.http.get({
                url,
            });
        };
    }
    // #endregion
    refreshCompanyUsersIndex(companyId) {
        const url = format(this.urls.postCompanyUsersIndex, { companyId });
        return this.http.post({
            url,
        });
    }
    postPackagesIndex() {
        const url = this.urls.postPackagesIndex;
        return this.http.post({
            url,
        });
    }
    deletePackagesIndex() {
        const url = this.urls.deletePackagesIndex;
        return this.http.delete({
            url,
        });
    }
    postPackagesReindex() {
        const url = this.urls.postPackagesReindex;
        return this.http.post({
            url,
        });
    }
    postGroupsIndex() {
        const url = this.urls.postGroupsIndex;
        return this.http.post({
            url,
        });
    }
    deleteGroupsIndex() {
        const url = this.urls.deleteGroupsIndex;
        return this.http.delete({
            url,
        });
    }
    postGroupsReindex() {
        const url = this.urls.postGroupsReindex;
        return this.http.post({
            url,
        });
    }
    postGroupsMembersIndex() {
        const url = this.urls.postGroupsMembersIndex;
        return this.http.post({
            url,
        });
    }
    deleteGroupsMembersIndex() {
        const url = this.urls.deleteGroupsMembersIndex;
        return this.http.delete({
            url,
        });
    }
    postGroupsMembersReindex() {
        const url = this.urls.postGroupsMembersReindex;
        return this.http.post({
            url,
        });
    }
};
SearchEngineManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.SearchEngineManagementApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], SearchEngineManagementApi);
export { SearchEngineManagementApi };
